export default __webpack_public_path__ + "static/media/lampas3-min.189804f7.jpeg";